/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function TransformConstraintsUnlocked(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'TransformConstraintsUnlocked',
      'aria-hidden': true,
      focusable: false,
      width:  10 * scale,
      height: 32 * scale,
      viewBox: '0 0 10 32',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('g', {"fill":"currentColor","fillRule":"evenodd"},createElement('path', {"d":"M7 8V0H6v8zm0 16v8H6v-8zM0 0h6v1H0zm0 31h6v1H0z","opacity":".3"}),createElement('path', {"d":"M9.003 16v-1.5a2.5 2.5 0 0 0-4.95-.5h1.04a1.5 1.5 0 0 1 2.916.5V16H4a1 1 0 0 0-1 1.01V20h7v-2.99A1 1 0 0 0 9.003 16M7 18.495c0 .28-.232.505-.5.505a.495.495 0 0 1-.5-.505v-.99c0-.28.232-.505.5-.505.276 0 .5.214.5.505z","opacity":".6"})))
}
